import { X } from "lucide-react";

interface IProps {
  onClose: () => void;
}

export const IntegrationIncompleteSection = ({ onClose }: IProps) => {
  return (
    <div className="flex flex-col gap-5 w-full h-full p-4">
      <X
        size={16}
        className="cursor-pointer self-end text-muted-foreground"
        style={{ width: '16px !important', height: '16px !important', minWidth: '16px', minHeight: '16px' }}
        onClick={onClose}
      />

      <div className="flex flex-col w-full h-full gap-5 justify-center items-center">
        <p className="text-center w-full text-[13px] text-muted-foreground">
          Finish setting up this connection in the configuration page.
        </p>
      </div>
    </div>
  );
};
